import { Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RouteConstants } from '../../constants/routes';

export class GuardHelper {
    /**
     * Sends user to our current "error" route page. This is a catch-all for any unexpected errors fow now.
     * @returns
     */
    static getErrorUrl(router: Router): Observable<UrlTree> {
        return of(router.createUrlTree([RouteConstants.Error]));
    }

    /**
     * Sends the user to the home route so they can login or register.
     * @param router
     * @returns
     */
    static getHomeUrl(router: Router): Observable<UrlTree> {
        return of(router.createUrlTree([RouteConstants.Home.getHomeUrl()]));
    }

    /**
     * Sends the user to the registration page.
     * @param router
     * @returns
     */
    static getRegistrationUrl(router: Router): Observable<UrlTree> {
        return of(router.createUrlTree([RouteConstants.UserRegistration]));
    }

    /**
     * Sends the user to the Go Overview page.
     * @param router
     * @returns
     */
    static getGoOverviewUrl(router: Router): Observable<UrlTree> {
        return of(
            router.createUrlTree([RouteConstants.Go.getFullRoute('overview')]),
        );
    }
}
